import * as React from 'react'
import { adminService } from '../../../../../services'
import { toast } from 'react-toastify'
import { Button, Form, Icon, Pagination, PaginationProps, Segment, Table } from 'semantic-ui-react'

type BannedIpState = {
  isLoading: boolean,
  totalPage: number,
  pageData?: IPageable<IBannedIp>,
  page: number,
  ip?: string,
  banned?: boolean,
}
export default class BannedIp extends React.Component {
  state: BannedIpState = {
    isLoading: true,
    page: 0,
    totalPage: 1,
  }

  componentDidMount() {
    this.loadAllIps(0)
  }

  loadAllIps(page: number, ip?: string) {
    adminService.getAllIp({page: page, ip: ip, banned: this.state.banned})
      .then(ips => {
        this.setState({
          isLoading: false,
          pageData: ips,
          totalPage: ips.totalPages,
          page: page,
        })
      })
      .catch(error => {
        toast.error('Không kết nối được với server! ' + error.message)
      })
  }

  banIp = (ip: IBannedIp) => {
    adminService.banIp(ip.ip)
      .then(ipBanned => {
        toast.info(`Ban ip ${ipBanned.ip} thành công!`)
        this.loadAllIps(this.state.page, this.state.ip)
      })
  }

  unBan = (ip: IBannedIp) => {
    adminService.unbanIp(ip.ip)
      .then(ipBanned => {
        toast.info(`UnBan ip ${ipBanned.ip} thành công!`)
        this.loadAllIps(this.state.page, this.state.ip)
      })
  }

  renderBody = (pageData?: IPageable<IBannedIp>) => {
    if (!pageData || !pageData.content) {
      return (<Table.Row>No IP</Table.Row>)
    }
    const ips = pageData.content
    return ips.map(ip => (
      <Table.Row>
        <Table.Cell>{ip.ip}</Table.Cell>
        <Table.Cell>{ip.attempt}</Table.Cell>
        <Table.Cell>{ip.banned ? 'Yes' : 'No'}</Table.Cell>
        <Table.Cell>{ip.message}</Table.Cell>
        <Table.Cell>{ip.numberItem}</Table.Cell>
        <Table.Cell>{ip.steamId}</Table.Cell>
        <Table.Cell>
          <Icon name={'lock'} onClick={() => this.banIp(ip)}/>
          <Icon name={'unlock'} onClick={() => this.unBan(ip)}/>
        </Table.Cell>
      </Table.Row>
    ))
  }

  handlePageChange = (event: React.MouseEvent<HTMLAnchorElement>, data: PaginationProps) => {
    let {page, ip} = this.state
    if (!data.activePage || data.activePage <= 0) {
      page = 0
    } else {
      page = Number(data.activePage) - 1
    }
    this.loadAllIps(page, ip)
  }

  onIpChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    const ip = event.target.value
    this.setState({
      ip: ip,
    })
  }

  onBannedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    if (event.target.value === 'true') {
      this.setState({ banned: true})
    } else if (event.target.value === 'false') {
      this.setState({ banned: false })
    } else {
      this.setState({ banned: undefined })
    }
  }

  render() {
    const {isLoading, pageData, totalPage, page, ip} = this.state
    return (
      <Segment loading={isLoading}>
        <Form>
          <Form.Group inline={true}>
            <Form.Field
              control={'input'}
              label={'IP'}
              name={'ip'}
              onChange={this.onIpChange}
              type={'text'}
              value={ip}
            />
            <Form.Field label="Banned" control="select" name={'banned'} onChange={this.onBannedChange}>
              <option value={undefined}/>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </Form.Field>
          </Form.Group>
          <Button type={'submit'} onClick={() => this.loadAllIps(page, ip)}>Search</Button>
        </Form>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>IP</Table.HeaderCell>
              <Table.HeaderCell>Attempt</Table.HeaderCell>
              <Table.HeaderCell>Banned</Table.HeaderCell>
              <Table.HeaderCell>Number Item</Table.HeaderCell>
              <Table.HeaderCell>Steam ID</Table.HeaderCell>
              <Table.HeaderCell>Message</Table.HeaderCell>
              <Table.HeaderCell>Edit</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {this.renderBody(pageData)}
        </Table>
        <Pagination
          totalPages={totalPage}
          activePage={page + 1}
          onPageChange={this.handlePageChange}
        />
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/containers/BannedIp.tsx